// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"100":"36a5572100fc126c","484":"f15fd858cc8a7467","957":"17aeef083046d4e2","980":"65ae0646a3d41323"}[chunkId] + ".js";
};